const { propOr } = require('ramda');

module.exports = function (value) {
  return propOr(
    {
      count: 0,
      users: [],
    },
    'value'
  )(value);
};
